module.exports = __webpack_public_path__ + "img/blcn.7e2b8a68.svg";